import * as React from 'react';
import styles from './Blob.module.esm.js';
import themes from '../../themes.module.esm.js';

var Blob = function (_a) {
    var theme = _a.theme;
    return (React.createElement("svg", { className: styles.blob, role: "presentation", viewBox: "0 0 480 419" },
        React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1" },
            React.createElement("g", { fill: "#19AC9F", transform: "translate(-735.000000, -4354.000000)" },
                React.createElement("g", { transform: "translate(0.000000, 4146.000000)" },
                    React.createElement("path", { className: themes[theme], d: "M836.057983,583.705846 C770.744959,448.999007 724.089099,265.115457 820.55493,200.251959 C917.02076,135.38846 969.63102,224.466453 1034.09836,277.535566 C1098.5657,330.60468 1184.5,333.348072 1184.5,416.637778 C1184.5,499.927484 1142.69737,529.566046 1089.98971,583.705846 C1037.28204,637.845646 901.371007,718.412685 836.057983,583.705846 Z", id: "Blob-teal", transform: "translate(975.000000, 417.500000) scale(-1, -1) rotate(90.000000) translate(-975.000000, -417.500000) " }))))));
};

export { Blob as default };
//# sourceMappingURL=Blob.esm.js.map
